
import React from 'react';
import { BLOCKS } from '@contentful/rich-text-types';

import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import { Box, Themed } from 'theme-ui';

import 'swiper/css';
import 'swiper/css/autoplay';
import './AdsBlocksSection.scss';

import BackgroundImage from '@src/components/BackgroundImage';

type DiscountIconProps = {
  color: string;
  discount: string;
};

function DiscountIcon({ color, discount }: DiscountIconProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 169.002 131.998">
      <g data-name="Group 1149">
        <path
          fill={color}
          d="M25 66C25 29.546 55.219 0 92.5 0a68.16 68.16 0 0143.117 15.217 10.576 10.576 0 017.881-3.483A10.382 10.382 0 01154 22a10.2 10.2 0 01-4.592 8.49A64.64 64.64 0 01160 66c0 36.448-30.217 66-67.5 66S25 102.447 25 66zM0 108.042a14.341 14.341 0 0114.5-14.175 14.18 14.18 0 110 28.354A14.343 14.343 0 010 108.042zm154 .98a7.5 7.5 0 117.5 7.332 7.419 7.419 0 01-7.5-7.333z"
          data-name="Union 49"
        ></path>
        <text
          fill="#fff"
          data-name="Svarstote tapti moky"
          fontFamily="Roboto-Regular, Roboto"
          fontSize="46"
          transform="translate(44 79.697)"
        >
          <tspan x="0" y="0">
            -{discount}%
          </tspan>
        </text>
      </g>
    </svg>
  );
}

type AdsBlock = {
  blokoTipas: 'Nuolaida' | 'Vizualas' | 'Vizualas Dalis Ploto';
  link: string;
  logo: ImageData;
  visually?: string;
  discountColor: string;
  discount: string;
};
type AdsBlocksSectionProps = {
  data: {
    title: string;
    backgroundColor: string;
    adsBlock: AdsBlock[];
  };
};

const AdsBlock = (data: AdsBlock) => {
  const visuallyImg = getImage(data?.visually);

  function renderByType() {
    switch (data.blokoTipas) {
      case 'Nuolaida': {
        return (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flex: 1,
              position: 'relative',
              padding: ['12px 16px', '22px 25px 22px 0px'],
            }}
          >
            <DiscountIcon color={data.discountColor} discount={data.discount} />
          </Box>
        );
      }
      case 'Vizualas Dalis Ploto': {
        return (
          <Box
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              position: 'relative',
              maxHeight: 'inherit',
              backgroundColor: 'red',
              height: '100%',
              width: '100%',
            }}
          >
            {data?.visually?.mimeType === 'image/svg+xml' ? (
              <img src={data.visually.url} />
            ) : (
              visuallyImg && (
                <GatsbyImage
                  sx={{
                    height: '100%',
                  }}
                  alt=""
                  imgStyle={{ height: '100%', width: 'auto' }}
                  image={visuallyImg}
                  // layout="constrained"
                />
              )
            )}
          </Box>
        );
      }
    }
  }
  // ok
  const option = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <Box>{children.map((e) => e.replace(/\n/g, ''))}</Box>
      ),
    },
  };
  return data.blokoTipas === 'Vizualas' ? (
    <Box
      onClick={() => (data?.link ? window.open(data?.link, '_blank') : null)}
      sx={{
        cursor: data?.link ? 'pointer' : 'default',
        borderRadius: '10px',
        // height: ['125px', '130px', '132px', '173px'],
        width: ['100%'],
        // maxHeight: '173px',
        maxHeight: ['125px', '170px'],
        maxWidth: ['313px', '430px'],

        aspectRatio: '1/0.4',
        overflow: 'hidden',
        alignSelf: 'center',
      }}
    >
      <BackgroundImage
        className="ads-blocks-section__background-image"
        image={visuallyImg}
      >
        <Box
          sx={{
            display: 'flex',
            padding: ['12px 16px', '22px 10px 22px 25px'],
            justifyContent: 'space-between',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'space-between',
            zIndex: 1,
          }}
        >
          <Box>
            {data?.shortText?.raw &&
              documentToReactComponents(JSON.parse(data.shortText.raw), option)}
          </Box>
          {data?.logo?.mimeType === 'image/svg+xml' ? (
            <img
              sx={{ maxWidth: ['125px', '185px'] }}
              src={data.logo.url}
              alt=""
            />
          ) : (
            data.logo && (
              <GatsbyImage
                sx={{ maxWidth: ['125px', '185px'] }}
                image={getImage(data.logo)}
                alt=""
              />
            )
          )}
        </Box>
      </BackgroundImage>
    </Box>
  ) : (
    <Box
      onClick={() => (data?.link ? window.open(data?.link, '_blank') : null)}
      sx={{
        overflow: 'hidden',
        cursor: data?.link ? 'pointer' : 'default',
        backgroundColor: 'white',
        borderRadius: '10px',
        height: ['125px', '130px', '132px', '173px'],
        aspectRatio: '1/0.4',
        display: 'flex',
        alignSelf: 'center',
        postion: 'relative',
        justifyContent: 'space-between',
      }}
    >
      <Box
        sx={{
          padding: ['12px 16px', '22px 10px 22px 25px'],
          display: 'flex',
          flexDirection: 'column',

          minWidth: '60%',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          zIndex: 1,
        }}
      >
        <Box>
          {data?.shortText?.raw &&
            documentToReactComponents(JSON.parse(data.shortText.raw), option)}
        </Box>
        {data?.logo?.mimeType === 'image/svg+xml' ? (
          <img
            src={data.logo?.url}
            sx={{ maxWidth: ['125px', '185px'] }}
            alt=""
          />
        ) : (
          <GatsbyImage
            sx={{ maxWidth: ['125px', '185px'] }}
            image={getImage(data?.logo)}
            alt=""
          />
        )}
      </Box>
      {renderByType()}
    </Box>
  );
};

export default function AdsBlocksSection({ data }: AdsBlocksSectionProps) {
  // const demo = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}];

  const SLIDER_CONFIG = {
    modules: [Autoplay],
    centeredSlidesBounds: true,
    loop: true,
    autoplay: {
      delay: 5000,
    },
    centeredSlides: true,
    breakpoints: {
      640: {
        spaceBetween: 20,
        slidesPerView: 1,
      },
      1024: {
        spaceBetween: 20,
        slidesPerView: data?.adsBlock?.length < 3 ? data?.adsBlock.length : 3,
      },
    },
  };
  return (
    <Box
      sx={{
        backgroundColor: data?.backgroundColor,
        padding: ['25px 0px 46px 0px', '34px 18px 87px 18px'],
        borderRadius: ['0px', '0px', '0px', '172px'],
        display: 'flex',
        overflow: 'hidden',
        flexDirection: 'column',
        margin: '34px 0px 48px 0',
      }}
    >
      <h2
        sx={{
          fontFamily: 'body',
          fontSize: 3,
          lineHeight: 'normal',
          marginBlockStart: '0px',
          marginBlockEnd: '0px',
          margin: ['0px 0px 23px 0px', '0px 0px 33px 0px'],
          textAlign: 'center',
          fontWeight: 'normal',
        }}
      >
        {data?.title}
      </h2>
      <Box>
        <Swiper {...SLIDER_CONFIG} sx={{ width: '90%' }}>
          {data?.adsBlock.map((item, index) => (
            <SwiperSlide
              key={'s' + index}
              style={{
                display: 'flex',
                justifyContent: 'center',
              }}
            >
              <AdsBlock {...item} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Box>
  );
}
